/** Every presenter while they fit in `max` places; past that, all but the last place, which says how many more. */
export function presentersShown<T>(speakers: T[], max: number): { shown: T[]; more: number } {
    const shown = speakers.length > max ? speakers.slice(0, max - 1) : speakers
    return { shown, more: speakers.length - shown.length }
}
